export function toDateInputValue(value) {
  if (!value) return '';
  const s = String(value).trim();
  const head = s.match(/^(\d{4}-\d{2}-\d{2})/);
  if (head) return head[1];
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return '';
  return d.toISOString().slice(0, 10);
}

/**
 * Transforme string dates into full valid date
 * @param {string} dateInputValue
 * @param {boolean} endOfDay - use 23:59:59.999 instead of 00:00:00.000
 * @returns {string}
 */
export function dateInputValueToIso(dateInputValue, endOfDay = true) {
  if (!dateInputValue) return null;
  const time = endOfDay ? '23:59:59.999Z' : '00:00:00.000Z';
  return new Date(`${dateInputValue}T${time}`).toISOString();
}
